import { render, staticRenderFns } from "./cadtransportadoras.vue?vue&type=template&id=8bab2908&"
import script from "./cadtransportadoras.vue?vue&type=script&lang=js&"
export * from "./cadtransportadoras.vue?vue&type=script&lang=js&"
import style0 from "./cadtransportadoras.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports